/**
 * @ngdoc directive
 * @name WcResponsiveTableModule.directive:wcColumnFilter
 * @restrict A
 * @scope
 * @param {string} wcColumnFilter The string of filter values of a datatable
 * @param {string} wcColumnFilterDelay The string of filter delay values of a datatable
 * @description
 * The wcColumnFilter directive adds filters to jquery datatable, this directive holds methods that are
 * related to filter operation.
 */



angular.module('WcResponsiveTableModule').directive('wcColumnFilter', ['$compile', '$timeout', '$document', '$filter', '_', 'WcTranslateConfiguratorService', '$translate', function ($compile, $timeout, $document, $filter, _, WcTranslateConfiguratorService, $translate) {
	return {
		restrict: 'A',
		require: ['wcColumnFilter', '^wcResponsiveTable'],
		scope: true,
		bindToController: {
			wcColumnFilter: '@',
			wcColumnFilterDelay: '@'
		},
		controllerAs: 'columnFilterController',
		controller: ['$scope', '$element', function ($scope, $element) {
			WcTranslateConfiguratorService.loadPartAndRefresh('WC-dataTable');

			var htmlDecode = function (input) {
				var e = $document[0].createElement('div');
				e.innerHTML = input;
				return e.childNodes[0].nodeValue;
			};

			var responsiveTableController = $element.parent().controller('wcResponsiveTable');

			this.tableScope = responsiveTableController.WcTableScopeService.getTableScope();
			var collection = responsiveTableController.WcTableCollectionService.getCollection();
			this.collection = collection;

			this.predicate = this.wcColumnFilter;
			this.wcColumnFilterDelay = this.wcColumnFilterDelay || 0;
			this.isMultiSelect = false;

			this.mathFilterOptions = [
				{id: '==', name: '='},
				{id: '<', name: htmlDecode('&lt;')},
				{id: '<=', name: htmlDecode('&le;')},
				{id: '>', name: htmlDecode('&gt;')},
				{id: '>=', name: htmlDecode('&ge;')},
				{id: '!=', name: htmlDecode('&ne;')}
			];


			//reassign our local collection var when an update has occurred.
			//also rerun the filters
			this.tableScope.$on('table.collection.update', angular.bind(this, function () {
				collection = responsiveTableController.WcTableCollectionService.getCollection();
				$timeout(angular.bind(this, function () {
					this.filterColumn();
				}), 0);
			}));

			this.filterColumn = function () {

				var activeFilterWrapper = responsiveTableController.element.find(".active-filters");

				responsiveTableController.WcTableCollectionService.filterEnabled = true;

				var filterEnabled = responsiveTableController.WcTableCollectionService.filterEnabled;
				var sortEnabled = responsiveTableController.WcTableCollectionService.sortEnabled;

				//TODO only handle one copy of the collection
				var filterArray = responsiveTableController.WcColumnFilterService.getColumnsToFilter();

                if(filterArray.length === 0) {
                    activeFilterWrapper.toggleClass("hidden", true);
                    responsiveTableController.WcTableCollectionService.filterEnabled = false;
                    responsiveTableController.WcTableCollectionService.setCollection(collection, sortEnabled, filterEnabled);
                }
                else {
                	activeFilterWrapper.toggleClass("hidden", false);
                    var filteredCollection = _.filter(collection, angular.bind(this, function(row) {
                        var match = false;
                        for (var i = 0; i < filterArray.length; i++) {
                        	if(filterArray[i].value == ""){
                        		match = true;
							}else if (_.get(row, filterArray[i].predicate)){
								if (angular.isArray(filterArray[i].value)) {
                                    for (var j = 0; j < filterArray[i].value.length; j++) {
                                        if (_.get(row, filterArray[i].predicate).toString().toLowerCase().indexOf(filterArray[i].value[j].toLowerCase()) > -1) {
                                            match = true;
                                        } else {
                                            return false;
                                        }
                                    }
                                }
                                else if (filterArray[i].isMathFilter) { //if mathFilter is true
                                    var mathOp = responsiveTableController.selectedMathFilterOption[filterArray[i].predicate].id;
                                    var filterString = filterArray[i].value;
                                    var filterNum = Number(filterString);
                                    var rowValue = Number(_.get(row, filterArray[i].predicate));
                                    if($scope.$eval(rowValue + mathOp + filterNum)){
                                        match = true;
                                    } else {
                                        return false;
                                    }
                                }else if (_.get(row, filterArray[i].predicate, 'default') !== 'default' && _.get(row, filterArray[i].predicate).toString().toLowerCase().indexOf(filterArray[i].value.toLowerCase()) > -1) {
                                    match = true;
                                }else{
                                    return false;
                                }
                            } else {
                                return false;
                            }

						}
						return match;
					}));

					responsiveTableController.WcTableCollectionService.setCollection(filteredCollection, sortEnabled, filterEnabled);
				}
			};

			this.dismissFilter = function (id) {
				var filterInput = $('input[wc-column-filter="' + id + '"], select[wc-column-filter="' + id + '"]');
				filterInput.val("");
				responsiveTableController.WcColumnFilterService.removeColumnToFilter(id);
				this.filterColumn();
				$(".active-filters ." + id.replace(".", "-")).remove();
                $element.parents("th").find('span.glyphicon-filter').remove();
			};

			this.filterListener = function () {
				var htmlPredicate = this.predicate.replace(".", "-");
				var elementVal = $element.val();
				var oldVal;
				if (_.find(responsiveTableController.WcColumnFilterService.getColumnsToFilter(), {'predicate': this.predicate})) {
					oldVal = _.find(responsiveTableController.WcColumnFilterService.getColumnsToFilter(), {'predicate': this.predicate}).value;
				}
				if (elementVal !== undefined && (elementVal !== "" || oldVal !== "") && (elementVal !== "" || oldVal !== undefined) && (elementVal !== oldVal || $element.attr('wc-math-filter') === "")) {
					responsiveTableController.WcColumnFilterService.setColumnsToFilter(this.predicate, elementVal, $element.attr('wc-math-filter') === "");
					this.filterColumn();
                    var filterIconFinder = $element.parents("th").find('span.glyphicon-filter');

					//in this section, we are working in the html. we can't use a dotted predicate there, as it will break the selectors.
					//so, replace the dots with hyphens so we can still use them.
					htmlPredicate = this.predicate.replace(".", "-");

					//if we have a value, we know we are filtering.
					//add or remove the heading indicator and adjust the active filter spans
					var activeFilterButton = responsiveTableController.element.find(".active-filters ." + htmlPredicate);

					if (elementVal !== "") {
                        var label = $element.parents("th").find('.header-text').text();
                        if (!filterIconFinder.length) {
                            if($element.parents("th").find('.header-icons').length>0 && !filterIconFinder.length ){
                                $element.parents("th").find('.header-icons').append('<span class="glyphicon glyphicon-filter"></span>');
                            }
                            else {
                                $timeout(function () {
                                    $element.parents("th").find('.header-text-wrapper').append('<span class="header-icons pull-right"><span class="glyphicon glyphicon-filter"></span></span>');
                                }, 0);
                            }
                            // $element.parent().prepend('<span class="glyphicon glyphicon-filter"></span>');
                        }
						/* Use this to display filter value*/
						/*if (activeFilterButton.length) {
						 // activeF	ilterButton.find('span:last-child').text(label + ': ' + JSON.stringify(elementVal, null, 1));
						 }
						 else {
						 responsiveTableController.element.find('.active-filters').append($compile('<button class="btn btn-active-filter ' + htmlPredicate + '" ng-click="columnFilterController.dismissFilter(\'' + columnFilterController.predicate + '\')"><span>' + label +'</span>&nbsp;&nbsp;<span class="glyphicon glyphicon-remove"></span></button>')($scope));
						 }*/
						if (!activeFilterButton.length) {
							responsiveTableController.element.find('.active-filters').append($compile('<button class="btn btn-active-filter ' + htmlPredicate + '" ng-click="columnFilterController.dismissFilter(\'' + this.predicate + '\')"><span>' + label + '</span>&nbsp;&nbsp;<span class="glyphicon glyphicon-remove"></span></button>')($scope));
						}
					}
					else if (elementVal === "") {
						filterIconFinder.remove();
						var activeFilterBox = activeFilterButton.parent();
						activeFilterButton.remove();
						if (!activeFilterBox.children().length) {
							responsiveTableController.element.find('.active-filters').toggleClass("hidden", true);
						}
					}
				}

                $scope.$broadcast('table.filter.complete');
			};

		}],
		link: function (scope, element, attrs, controllers, filter) { // jshint ignore:line
			var columnFilterController = controllers[0];
			var responsiveTableController = controllers[1];

            if(element.attr('wc-math-filter') === "") {
                responsiveTableController.selectedMathFilterOption[columnFilterController.predicate] = columnFilterController.mathFilterOptions[0];
                element.wrap('<div class="row wc-math-filter-row"><div class="col-xs-8">' +
                    '</div></div>');
                element.parent().before($compile('<div class="col-xs-4 math-dropdown"><select class="form-control input-sm" ng-change="columnFilterController.filterListener()" ' +
                    'ng-options="option.name for option in columnFilterController.mathFilterOptions track by option.id" ' +
                    'ng-model="columnFilterController.tableScope.responsiveTableController.selectedMathFilterOption[columnFilterController.predicate]" id="wc-math-filter-'+columnFilterController.predicate.replace(".", "-")+'">' +
                    '</select></div>')(scope));

            }

			if (element.prop('tagName') === 'SELECT' && !element.attr('wc-math-filter')) {
				columnFilterController.isMultiSelect = element.attr("multiple");
				var options = (_.uniq(_.map(columnFilterController.collection, columnFilterController.predicate))).sort();

				var option = $('<option></option>');
				if (!columnFilterController.isMultiSelect) {
					option.attr('value', '');
					option.text($translate.instant('columnFilter.selectDefaultText'));
					element.append(option);
				}

				_.each(options, function (item) {
					var option = $('<option></option>');
					option.attr('value', item);
					option.text(item);
					element.append(option);
				});

				element.on('change', columnFilterController.filterListener.bind(columnFilterController));
			} else {
				element.keyup(_.debounce(columnFilterController.filterListener.bind(columnFilterController), columnFilterController.wcColumnFilterDelay));
			}

			//prevent sort action from firing when a click happens in a filter box
			element.on('click', function (event) {
				event.stopPropagation();
			});

		}
	};
}]);
